<template>
 <div class="notif-menu">
  <b-dropdown id="dropdownNotif" no-caret class="dropdown-notif" right>
    <template slot="button-content">
      <a @click="registrarVisualizacaoUltimasNotificacoes(ultimasNotificacoesIds)" class="nav-link sino-menu" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="far fa-bell"></i><i class="fas" :class="classeCirculo"></i></a>
    </template>
    <p class="pl-4">Notificações</p>
    <div class="dropdown-divider"></div>
    <a v-for="notif in ultimasNotificacoes" :key="notif.id" @click="registrarAcesso(notif)" class="dropdown-item" :class="notif.tipo_notificacao.categoria" :href="notif.url" target="_blank">
      <div class="d-flex align-items-center">
        <div class="text-center">
          <i class="fas" :class="notif.tipo_notificacao.icone"></i>
        </div>
        <div>
          <span>{{ notif.tipo_notificacao.descricao }}</span>
          <p>{{ notif.notificacao }}</p>
          <p>{{ dias(notif.created_at) }}</p>
        </div>
      </div>
      <div class="dropdown-divider"></div>
    </a>
    <a @click="$router.push('/notificacoes')">Ver todas</a>
  </b-dropdown>
</div>
</template>

<script>
import DateUtils from '@/core/utils/date-utils'
import NotificacaoAPI from '@/api/notificacao-api'

export default {
  name: 'Notificacoes',
  data () {
    return {
      notif: null,
      novaNotificacao: '',
      paginaAtual: 1,
      ultimasNotificacoes: [],
      ultimasNotificacoesIds: []
    }
  },
  mounted () {
    this.obterNotificacao(null, this.paginaAtual)
  },
  computed: {
    classeCirculo () {
      return this.novaNotificacao ? 'fa-circle' : null
    }
  },
  methods: {
    async obterNotificacao (id, pagina) {
      let resposta = await NotificacaoAPI.obterNotificacao(id, pagina)
      let data = resposta.notificacoes.data
      let novaNotificacao = resposta.notificacoes.nova_notificacao
      this.novaNotificacao = novaNotificacao
      this.ultimasNotificacoes = data.slice(0, 3)
      this.ultimasNotificacoesIds = this.ultimasNotificacoes.map(item => item.id)
    },
    registrarVisualizacaoUltimasNotificacoes () {
      NotificacaoAPI.registrarVisualizacao(this.ultimasNotificacoesIds)
    },
    registrarAcesso (notif) {
      NotificacaoAPI.registrarAcesso(notif.id)
    },
    dias (createdAt) {
      return DateUtils.diasAtras(createdAt)
    }
  }
}
</script>
